import { useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';

import { VirtualCardOrderFlowDocument } from './virtualCardOrderFlow.gql';

export function useVirtualCardOrderFlowQuery() {
  const { companyProfileId } = useCompanyContext();

  return useQuery(VirtualCardOrderFlowDocument, {
    // We don't need to store this query in the cache because we will need to get the latest quotas after each card order anyway,
    // furthermore this way apollo does not override the retrieved Package from newVirtualCardPrice with the one from virtualCardPriceAfterQuotaReached
    // and returns the correct value for both queries
    fetchPolicy: 'no-cache',
    skip: !companyProfileId,
    variables: { companyProfileId: companyProfileId || '' },
  });
}
